import { render } from "./PicsView.vue?vue&type=template&id=c050401e"
import script from "./PicsView.vue?vue&type=script&lang=js"
export * from "./PicsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__